module.exports = __webpack_public_path__ + "static/img/torsoScaled22.a682a45b.png";